import { Component, OnInit } from '@angular/core';
import { VacanciesService } from '../../services'
@Component({
    selector: 'app-vacancies',
    templateUrl: './vacancies.component.html',
    styleUrls: ['./vacancies.component.scss']
})

export class VacanciesComponent implements OnInit {
	vacancies = [];

    constructor(private vacanciesService: VacanciesService) { }

    ngOnInit() {
    	this.vacanciesService.getAll(4).subscribe((res: any)=>{this.vacancies = res.data})
    }

}
